import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {Menu} from "primeng/menu";

@Component({
    selector: 'dmp-button-menu',
    templateUrl: './button-menu.component.html',
    styleUrls: ['./button-menu.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ButtonMenuComponent implements OnInit {
    @Input() items: MenuItem[];
    @Input() disabled = false;
    /** Bouton rond (`p-button-rounded`) : largeur et hauteur égales, fixées par le thème. */
    @Input() rounded = false;


	@Output() onOpen = new EventEmitter<Event>();

    constructor(private eRef: ElementRef) {}

    ngOnInit(): void {

    }


    toggle(menuItem: Menu, $event) {
        this.onOpen.next($event);
        menuItem.toggle($event);
    }
}
